






































import { Component, Prop, Vue } from 'vue-property-decorator'
import { chain, map, sortBy } from 'lodash'
import { CircuitExercise, Exercise, VuetifySelectItem } from '@/interfaces'
import { emptyArray } from '@/utils'
import EditRepetitionDialog from '@/components/dialogs/EditRepetitionDialog.vue'

@Component({
  components: { EditRepetitionDialog }
})
export default class CircuitExerciseList extends Vue {
  @Prop({ default: emptyArray }) circuitExercises!: CircuitExercise[]

  dialogs: any = {
    editRepetition: false
  }

  selectedRepetition: any = null

  get exerciseItems (): VuetifySelectItem[] {
    const items = map(this.$store.getters['exercises/all'], (exercise: Exercise) => {
      return {
        text: exercise.name.en,
        value: exercise.id
      }
    })

    return sortBy(items, 'text')
  }

  formatWeightDisplay (weights: any, gender: string) {
    if (!weights) {
      return 'NONE'
    }

    const genderWeights = weights[gender]

    return [genderWeights.beginner, genderWeights.intermediate, genderWeights.advanced].join(', ')
  }

  addExercise () {
    this.circuitExercises.push({
      exerciseId: '',
      repetitions: []
    })
  }

  addRepetition (exerciseIndex: number) {
    if (this.circuitExercises[exerciseIndex]) {
      if (!this.circuitExercises[exerciseIndex].repetitions) {
        this.$set(this.circuitExercises[exerciseIndex], 'repetitions', [])
      }

      this.circuitExercises[exerciseIndex].repetitions.push({
        weights: {
          female: {
            beginner: 10,
            intermediate: 20,
            advanced: 40
          },
          male: {
            beginner: 15,
            intermediate: 25,
            advanced: 50
          }
        },
        quantity: 15
      })
    }
  }

  editRepetition (exerciseIndex: number, repetitionIndex: number) {
    if (this.circuitExercises[exerciseIndex]) {
      if (!this.circuitExercises[exerciseIndex].repetitions[repetitionIndex].weights) {
        this.circuitExercises[exerciseIndex].repetitions[repetitionIndex].weights = {
          female: {
            beginner: 10,
            intermediate: 20,
            advanced: 40
          },
          male: {
            beginner: 15,
            intermediate: 25,
            advanced: 50
          }
        }
      }

      this.selectedRepetition = this.circuitExercises[exerciseIndex].repetitions[repetitionIndex]
      this.dialogs.editRepetition = true
    }
  }

  removeExercise (index: number) {
    Vue.delete(this.circuitExercises, index)
  }

  removeRepetition (exerciseIndex: number, repetitionIndex: number) {
    if (this.circuitExercises[exerciseIndex]) {
      Vue.delete(this.circuitExercises[exerciseIndex].repetitions, repetitionIndex)
    }
  }
}
